import React from "react";
import { connect } from "react-redux";
import UserNotes from "../components/UserNotes";
import {
  fetchUserIDWithFullMemberInfoNeeded,
  fetchFullMemberInfoNeeded,
} from "../actions/search";
import { getNoteTags, setMemberNotePinStatus } from "../actions/members";

import selectedMemberNotes from "../selectors/selectedMember";

const UserNotesContainer = (props) => <UserNotes {...props} />;

const mapStateToProps = selectedMemberNotes();

const mapDispatchToProps = (dispatch) => ({
  onfetchFullMemberInfoNeeded: (member) =>
    dispatch(fetchFullMemberInfoNeeded(member)),
  onFetchUserIDWithFullMemberInfoNeeded: (member) =>
    dispatch(fetchUserIDWithFullMemberInfoNeeded(member)),
  onGetNoteCategories: () => dispatch(getNoteTags()),
  onSetPinStatus: (id, new_status, member) => {dispatch(setMemberNotePinStatus(id, new_status, member))},
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(UserNotesContainer);
